export type UpdateComponentAttributesRequest = {
  dipByRgn: string;
  cpntId: string;
  godFlg: string;
  cpntAttrList: CpntAttr[];
};

export type CpntAttr = {
  cpntPjtId: string;
  index: number;
  envTypeCd: string;
  cpntAttrNum: string;
  stngVal: string;
  updateDateTime: string;
};
